<template>
<div id="App">
  <el-container :class="comp">
      <el-header style="padding-right:0;">
        <div id="title"><span @click="comp = 'landing'">Nature + Nurture</span></div>
        <div id="menu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" text-color="white" active-text-color="white" menu-trigger="click">
          <el-menu-item index="1" @click="comp = 'origins'">Origins</el-menu-item>
          <el-submenu index="2">
            <template #title>Structure</template>
            <el-menu-item index="2-1" @click="comp = 'schedule'">Schedule</el-menu-item>
            <el-menu-item index="2-2" @click="comp = 'supplies'">Supplies</el-menu-item>
            <el-menu-item index="2-3" @click="comp = 'curriculum'">Curriculum</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template #title>Outcomes</template>
            <el-menu-item index="3-1" @click="comp = 'academic'">Academic</el-menu-item>
            <el-menu-item index="3-2" @click="comp = 'mental'">Mental</el-menu-item>
            <el-menu-item index="3-3" @click="comp = 'physical'">Physical</el-menu-item>
          </el-submenu>
          <el-menu-item index="4" @click="comp = 'implement'">Implementation</el-menu-item>
        </el-menu>
        </div>
      </el-header>
      <el-main>
        <component
          :is="comp"/>
      </el-main>
  </el-container>
</div>
</template>

<script>
import landing from './components/landing'
import origins from './components/origins'
import schedule from './components/schedule'
import curriculum from './components/curriculum'
import supplies from './components/supplies'
import academic from './components/academic'
import mental from './components/mental'
import physical from './components/physical'
import implement from './components/implement'

export default {
  name: 'App',
  data() {
    return {
    comp: `landing`
    }
  },
  components: {
      landing,
      schedule,
      curriculum,
      supplies,
      origins,
      academic,
      mental,
      physical,
      implement
  },
  setup() {
  }
}
</script>

<style>
@font-face {
    font-family: 'Wild';
    src: url("./assets/Wild Nature.ttf") format("truetype");
  }
  
@font-face {
    font-family: 'Josefin';
    src: url("./assets/JosefinSlab-Regular.ttf") format("truetype");
  }

@font-face {
    font-family: 'JosefinB';
    src: url("./assets/JosefinSlab-SemiBold.ttf") format("truetype");
  }
  
.schedule, .supplies, .curriculum, .implement {
  background-color: #839788;
}

.landing, .academic, .mental, .physical, .origins {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.origins {
  background-image: url(./assets/forest4.jpg);
}

.landing {
  background-image: url(./assets/forest1.jpg);
}

.academic, .mental, .physical {
  background-image: url(./assets/forest5.jpg);
}

body {margin: 0;}

#title {
  width: 40%;
  color: white;
  font-family: Wild;
  font-size: 4vw;
  float:left;
}

#menu {
  width: 60%;
  font-family: Josefin;
  float:left;
}

#labels, #graphs {
    /*min-height: 10%;*/
    width: 100%;
}

#forest_label, #traditional_label, #forest_graph, #traditional_graph {
    height: 100%;
    width:50%;
    float: left;
}

#forest_text, #traditional_text {
    color: 	white;
    font-family: Josefin;
    font-size: 2vw;
    /*background-color: #666666;*/
    /*opacity: .85;*/
    text-align: center;
    margin: auto;
    width: 15%;
    padding: 5%;
}

#forest, #traditional {
    width:100%;
    height:920px;
}

#context {
    color: white;
    font-family: Josefin;
    font-size: 1.5vw;
    margin: 2% 10% 1% 10%;
    text-align: center;
    background-color: #839788d9;
}

#forest_sp, #traditional_sp {
    width:100%;
    height:780px;
}

#forest_sp1, #traditional_sp1 {
    width:100%;
    height:700px;
}

.el-menu {
  float: right;
  padding-top: 1%;
}

.el-main, .el-container, .el-component {
  width: 100%;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-dropdown-menu, .el-menu, .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
  background-color: #839788b3;
  font-family: Josefin;
  color: white;
}

.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
  color: white;
}

.el-menu-item, .el-submenu__title {
  font-size: 1.3vw;
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: #ffffff00;
}

.el-menu-item:focus, .el-menu-item:hover {
  background-color: #ffffff00;
}
  
.el-popper.is-light {
  background-color: #ffffff00;
}

</style>
